export enum ApplianceTypeEnum {
  All = 'All',
  Protected = 'Protected',
  Expiring = 'Protection expiring',
  Expired = 'Protection expired',
  Cancelled = 'Protection cancelled',
  MultiplanProtected = 'Protected by multiplan',
  MultiplanExpiring = 'Multiplan protection expiring',
  MultiplanExpired = 'Multiplan protection expired',
  MultiplanCancelled = 'MultiplanCancelled',
}

export enum PlanStateTypeEnum {
  RENEWAL = 'RENEWAL',
  LAPSED = 'LAPSED',
  CANCELLED = 'CANCELLED',
  COVERED = 'COVERED',
  ALL = 'ALL',
}

export enum PlanTypeEnum {
  CUSTOMER_PLAN = 'CUSTOMER_PLAN',
  LANDLORD_PLAN = 'LANDLORD_PLAN',
}

export enum ClaimActionTypeEnum {
  REQUEST_REPAIR = 'REQUEST_REPAIR',
  BOOK_ENGINEER = 'BOOK_ENGINEER',
  INCOMPLETE_FORM = 'INCOMPLETE_FORM',
  TRACK_REPAIR = 'TRACK_REPAIR',
}

export enum PlanActionButtonTypeEnum {
  GetProtection = 'Get Protection',
  ReactivatePlan = 'Reactivate Plan',
  TryRepairAndCare = 'Try Repair And Care',
  Manage = 'Manage',
  BookRepair = 'Book Service',
  RenewPlan = 'Renew Plan',
  TrackRepair = 'Track Repair',
  ViewPlan = 'View plan details',
  BookOrTrackRepair = 'Manage my repair',
  Cancelled = 'View cancelled plan details',
  Expired = 'View expired plan details',
}

export enum ClaimStatusTypeEnum {
  ActiveRepair = 'Active Repair',
  BookingInProgress = 'Booking in progress',
  ManualReferral = 'Manual Referral',
  RemedialWorkRequired = 'REMEDIAL WORK REQUIRED',
  RemedialWorkComplete = 'CLAIM COMPLETE - REMEDIAL WORK REQUIRED',
  RemedialWorkIDIssued = 'CLAIM COMPLETE - WARNING NOTICE (ID) ISSUED',
  RemedialWorkARIssued = 'CLAIM COMPLETE - WARNING NOTICE (AR) ISSUED',
  RemedialWorkRequiredV2 = 'Safety issue',
  RepairBookingNeeded = 'Repair booking needed',
  RepairInProgress = 'Repair in progress',
  RepairRequestCancelled = 'Repair request cancelled',
  SparePartsNeeded = 'Spare parts needed',
  VisitFailed = 'Visit failed - to be rearranged',
  VisitMissed = 'Engineer visit missed',
  AppointmentRequired = 'Appointment required',
  NewVisitNeeded = 'New visit needed',
  ThirdFieldCallRequired = '3RD FIELD CALL REQUIRED',
}

export enum PlanContractTypeCodeEnum {
  IndeterminatePayMonthly = 'INS',
}

export enum PlanContractProductTypeEnum {
  PlumbingAndDrainage = 'PD',
}

export const REMEDIAL_WORK_PHONE_NUMBER = '0333 000 4966';
